let localUUID = 0;
export const createUUID = () => {
  localUUID += 1;
  return `localid-${localUUID}`;
};
